/* ============================================================
   Zampe & Cuori — megamenu desktop
   Click-to-open via <details> nativo. Questo file gestisce:
     - click-outside chiude i megamenu aperti
     - ESC chiude tutti
     - click su una sotto-voce chiude il proprio megamenu (così
       quando il link naviga, il panel resta chiuso sul ritorno)
   ============================================================ */
(function () {
  'use strict';

  const megamenus = document.querySelectorAll('[data-zc-megamenu]');
  if (!megamenus.length) return;

  function closeAll() {
    megamenus.forEach((m) => m.removeAttribute('open'));
  }

  // Click outside chiude tutti i megamenu aperti
  document.addEventListener('click', (event) => {
    megamenus.forEach((m) => {
      if (m.hasAttribute('open') && !m.contains(event.target)) {
        m.removeAttribute('open');
      }
    });
  });

  // ESC chiude tutti
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
    }
  });

  // Click su una sotto-voce: chiude il proprio megamenu prima della
  // navigazione. Il browser segue il link normalmente.
  megamenus.forEach((m) => {
    const panel = m.querySelector('.zc-megamenu__panel');
    if (!panel) return;
    panel.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        m.removeAttribute('open');
      }
    });
  });
})();
